import { produce } from 'immer';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import ivrsResource from 'src/actions/ivrs/ivrsResource';
import useRouter from 'src/presentation/hooks/useRouter';

type SaveHandlerProps = {
  params: {
    id: string;
    version: number;
  };
  attrs: {
    id: string;
    name: string;
    version: number;
  };
  workingState: any;
};

function useCopyIvr({ closeModal, params }) {
  const dispatch = useDispatch();
  const { history } = useRouter();
  const { copyIvr, validate } = ivrsResource.effects;
  const { resetErrors } = ivrsResource.actions;

  const copyHandler = async ({ workingState }: SaveHandlerProps): Promise<void> => {
    dispatch(resetErrors({}));
    const stateForValidation = produce(workingState, draft => {
      draft.name = get(draft, 'name', '').trim().toLowerCase();
    });
    const isValid = !!dispatch(validate(stateForValidation));

    if (!isValid) {
      return;
    }

    const { id } = workingState;
    await dispatch(copyIvr(params, workingState));
    closeModal && closeModal();
    history.push(`/ivrs/${id}`);
  };

  return copyHandler;
}

export default useCopyIvr;
